import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { SidebarProvider } from './components/ui/sidebar';
import { ToastProvider } from './components/ui/toast';
import { FirebaseProvider } from './hooks/use-firebase';
import { UserContextProvider } from './hooks/use-user';
import { InventoryContextProvider } from './hooks/use-inventory';
import { Toaster } from 'sonner';
import { App } from './app';
import { TooltipProvider } from './components/ui';
import { SubscriptionContentProvider } from './hooks/subscriptionProvider';
import { ThemeProvider } from './hooks/use-theme';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <StrictMode>
    <ThemeProvider>
      <ToastProvider>
        <TooltipProvider>
          <FirebaseProvider>
            <UserContextProvider>
              <InventoryContextProvider>
                <SubscriptionContentProvider>
                  <Toaster position="top-center" />
                  <App />
                </SubscriptionContentProvider>
              </InventoryContextProvider>
            </UserContextProvider>
          </FirebaseProvider>
        </TooltipProvider>
      </ToastProvider>
    </ThemeProvider>
  </StrictMode>
);
